import { ROUTE_IDS } from '../experience/routes/ids.js';
import { PLATFORM_ROOT_ACCESS_PROFILE } from './personas/platform-root.access-profile.js';
import { ORGANIZATION_ADMIN_ACCESS_PROFILE } from './personas/organization-admin.access-profile.js';
import { INVESTMENT_DOMAIN_MODULES } from '../modules/domain-bundles.js';
const PLATFORM_ADMIN_PRIMARY_NAVIGATION = [
    ROUTE_IDS.DASHBOARD,
    ROUTE_IDS.DATA_HUB,
    ROUTE_IDS.REPORTS,
    ROUTE_IDS.ADMIN_HUB,
];
const ORGANIZATION_PRIMARY_NAVIGATION = [
    ROUTE_IDS.DASHBOARD,
    ROUTE_IDS.DATA_HUB,
    ROUTE_IDS.REPORTS,
    ROUTE_IDS.ADMIN_HUB,
];
const CLIENT_PRIMARY_NAVIGATION = [
    ROUTE_IDS.DASHBOARD,
    ROUTE_IDS.REPORTS,
];
const PLATFORM_MODULES = ['PLATFORM', 'ADMIN', 'NAVIGATION', 'DASHBOARD', 'SETTINGS'];
const ORG_MODULES = ['DASHBOARD', 'DATA', 'REPORTING', 'INVESTMENT', 'ADMIN', 'NAVIGATION', 'SETTINGS'];
const CLIENT_MODULES = ['DASHBOARD', 'REPORTING', 'INVESTMENT', 'NAVIGATION', 'SETTINGS'];
const AVATAR_PLATFORM = [
    ROUTE_IDS.SETTINGS_PROFILE,
    ROUTE_IDS.SETTINGS_SECURITY,
];
export const PERSONA_POLICY_REGISTRY = {
    PLATFORM_ROOT: {
        persona: 'PLATFORM_ROOT',
        scopePolicy: {
            allowedScopeKinds: [...PLATFORM_ROOT_ACCESS_PROFILE.scope.allowedKinds],
            defaultScopeKind: PLATFORM_ROOT_ACCESS_PROFILE.scope.defaultKind,
            organizationRequired: PLATFORM_ROOT_ACCESS_PROFILE.scope.organizationRequired,
            branchRequired: PLATFORM_ROOT_ACCESS_PROFILE.scope.branchRequired,
            clientRequired: PLATFORM_ROOT_ACCESS_PROFILE.scope.clientRequired,
            portfolioOptional: PLATFORM_ROOT_ACCESS_PROFILE.context.maySelectPortfolio,
        },
        ownershipPolicy: PLATFORM_ROOT_ACCESS_PROFILE.scope.ownershipPolicy,
        defaultLandingRouteId: PLATFORM_ROOT_ACCESS_PROFILE.navigation.landingRouteId,
        navigation: {
            candidatePrimaryRouteIds: [...PLATFORM_ROOT_ACCESS_PROFILE.navigation.primaryRouteIds],
            avatarRouteIds: [...PLATFORM_ROOT_ACCESS_PROFILE.navigation.avatarRouteIds],
            structurallyForbiddenRouteIds: [...PLATFORM_ROOT_ACCESS_PROFILE.navigation.structurallyDeniedRouteIds],
            conditionallyAvailableRouteIds: [],
        },
        administration: {
            managesOrganizations: true,
            managesPlatformModules: true,
            managesPlatformUsers: true,
            managesBranches: false,
            managesOrganizationModules: false,
            managesOrganizationUsers: false,
            managesRoles: false,
            managesClients: false,
        },
        dataVisibility: {
            platformMetadata: true,
            organizationBusinessData: 'DELEGATED_ONLY',
        },
        mutationPolicy: PLATFORM_ROOT_ACCESS_PROFILE.mutationPolicy,
        defaultPermissionBundleIds: ['platform.root'],
        baselineModuleIds: [...PLATFORM_ROOT_ACCESS_PROFILE.modules.baseline],
        principalContextSwitching: {
            organization: PLATFORM_ROOT_ACCESS_PROFILE.context.maySwitchOrganization,
            branch: PLATFORM_ROOT_ACCESS_PROFILE.context.maySwitchBranch,
        },
        resourceScopeSelection: {
            client: PLATFORM_ROOT_ACCESS_PROFILE.context.maySelectClient,
            portfolio: PLATFORM_ROOT_ACCESS_PROFILE.context.maySelectPortfolio,
        },
        supportDelegation: {
            mayInitiate: PLATFORM_ROOT_ACCESS_PROFILE.delegation.mayInitiate,
            mayReceive: PLATFORM_ROOT_ACCESS_PROFILE.delegation.mayReceive,
            organizationDataRequiresDelegation: PLATFORM_ROOT_ACCESS_PROFILE.delegation.organizationDataRequiresDelegation,
        },
    },
    PLATFORM_ADMIN: {
        persona: 'PLATFORM_ADMIN',
        scopePolicy: {
            allowedScopeKinds: ['PLATFORM'],
            defaultScopeKind: 'PLATFORM',
            organizationRequired: false,
            branchRequired: false,
            clientRequired: false,
            portfolioOptional: false,
        },
        ownershipPolicy: 'PLATFORM',
        defaultLandingRouteId: ROUTE_IDS.DASHBOARD,
        navigation: {
            candidatePrimaryRouteIds: [...PLATFORM_ADMIN_PRIMARY_NAVIGATION],
            avatarRouteIds: [...AVATAR_PLATFORM],
            structurallyForbiddenRouteIds: [],
            conditionallyAvailableRouteIds: [],
        },
        administration: {
            managesOrganizations: true,
            managesPlatformModules: true,
            managesPlatformUsers: true,
            managesBranches: false,
            managesOrganizationModules: false,
            managesOrganizationUsers: false,
            managesRoles: false,
            managesClients: false,
        },
        dataVisibility: {
            platformMetadata: true,
            organizationBusinessData: 'DELEGATED_ONLY',
        },
        mutationPolicy: 'ASSIGNED_OPERATIONS',
        defaultPermissionBundleIds: ['platform.admin'],
        baselineModuleIds: PLATFORM_MODULES,
        principalContextSwitching: {
            organization: false,
            branch: false,
        },
        resourceScopeSelection: {
            client: false,
            portfolio: false,
        },
        supportDelegation: {
            mayInitiate: true,
            mayReceive: false,
            organizationDataRequiresDelegation: true,
        },
    },
    PLATFORM_USER: {
        persona: 'PLATFORM_USER',
        scopePolicy: {
            allowedScopeKinds: ['PLATFORM'],
            defaultScopeKind: 'PLATFORM',
            organizationRequired: false,
            branchRequired: false,
            clientRequired: false,
            portfolioOptional: false,
        },
        ownershipPolicy: 'PLATFORM',
        defaultLandingRouteId: ROUTE_IDS.DASHBOARD,
        navigation: {
            candidatePrimaryRouteIds: [ROUTE_IDS.DASHBOARD],
            avatarRouteIds: [...AVATAR_PLATFORM],
            structurallyForbiddenRouteIds: [ROUTE_IDS.ADMIN_HUB, ROUTE_IDS.DATA_HUB, ROUTE_IDS.REPORTS],
            conditionallyAvailableRouteIds: [],
        },
        administration: {
            managesOrganizations: false,
            managesPlatformModules: false,
            managesPlatformUsers: false,
            managesBranches: false,
            managesOrganizationModules: false,
            managesOrganizationUsers: false,
            managesRoles: false,
            managesClients: false,
        },
        dataVisibility: {
            platformMetadata: true,
            organizationBusinessData: 'NONE',
        },
        mutationPolicy: 'READ_ONLY',
        defaultPermissionBundleIds: ['platform.user'],
        baselineModuleIds: ['PLATFORM', 'NAVIGATION', 'DASHBOARD', 'SETTINGS'],
        principalContextSwitching: {
            organization: false,
            branch: false,
        },
        resourceScopeSelection: {
            client: false,
            portfolio: false,
        },
        supportDelegation: {
            mayInitiate: false,
            mayReceive: false,
            organizationDataRequiresDelegation: true,
        },
    },
    ORG_ADMIN: {
        persona: 'ORG_ADMIN',
        scopePolicy: {
            allowedScopeKinds: [...ORGANIZATION_ADMIN_ACCESS_PROFILE.scope.allowedKinds],
            defaultScopeKind: 'ORGANIZATION',
            organizationRequired: true,
            branchRequired: false,
            clientRequired: false,
            portfolioOptional: true,
        },
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        defaultLandingRouteId: ROUTE_IDS.DASHBOARD,
        navigation: {
            candidatePrimaryRouteIds: [...ORGANIZATION_PRIMARY_NAVIGATION],
            avatarRouteIds: [...ORGANIZATION_ADMIN_ACCESS_PROFILE.navigation.avatarRouteIds],
            structurallyForbiddenRouteIds: [...ORGANIZATION_ADMIN_ACCESS_PROFILE.navigation.structurallyDeniedRouteIds],
            conditionallyAvailableRouteIds: [],
        },
        administration: {
            managesOrganizations: false,
            managesPlatformModules: false,
            managesPlatformUsers: false,
            managesBranches: true,
            managesOrganizationModules: true,
            managesOrganizationUsers: true,
            managesRoles: true,
            managesClients: true,
        },
        dataVisibility: {
            platformMetadata: false,
            organizationBusinessData: 'ACTIVE_ORGANIZATION',
        },
        mutationPolicy: 'FULL_WITHIN_SCOPE',
        defaultPermissionBundleIds: ['organization.admin'],
        baselineModuleIds: [...INVESTMENT_DOMAIN_MODULES],
        principalContextSwitching: {
            organization: ORGANIZATION_ADMIN_ACCESS_PROFILE.context.maySwitchOrganization,
            branch: true,
        },
        resourceScopeSelection: {
            client: true,
            portfolio: true,
        },
        supportDelegation: {
            mayInitiate: false,
            mayReceive: true,
            organizationDataRequiresDelegation: false,
        },
    },
    ORG_USER: {
        persona: 'ORG_USER',
        scopePolicy: {
            allowedScopeKinds: ['ORGANIZATION', 'BRANCH'],
            defaultScopeKind: 'ORGANIZATION',
            organizationRequired: true,
            branchRequired: false,
            clientRequired: false,
            portfolioOptional: true,
        },
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        defaultLandingRouteId: ROUTE_IDS.DASHBOARD,
        navigation: {
            candidatePrimaryRouteIds: [ROUTE_IDS.DASHBOARD, ROUTE_IDS.DATA_HUB, ROUTE_IDS.REPORTS],
            avatarRouteIds: [...AVATAR_PLATFORM],
            structurallyForbiddenRouteIds: [],
            conditionallyAvailableRouteIds: [ROUTE_IDS.ADMIN_HUB],
        },
        administration: {
            managesOrganizations: false,
            managesPlatformModules: false,
            managesPlatformUsers: false,
            managesBranches: false,
            managesOrganizationModules: false,
            managesOrganizationUsers: false,
            managesRoles: false,
            managesClients: false,
        },
        dataVisibility: {
            platformMetadata: false,
            organizationBusinessData: 'ACTIVE_ORGANIZATION',
        },
        mutationPolicy: 'ASSIGNED_OPERATIONS',
        defaultPermissionBundleIds: ['organization.user.base'],
        baselineModuleIds: ORG_MODULES,
        principalContextSwitching: {
            organization: false,
            branch: true,
        },
        resourceScopeSelection: {
            client: true,
            portfolio: true,
        },
        supportDelegation: {
            mayInitiate: false,
            mayReceive: true,
            organizationDataRequiresDelegation: false,
        },
    },
    ORG_CLIENT: {
        persona: 'ORG_CLIENT',
        scopePolicy: {
            allowedScopeKinds: ['CLIENT', 'PORTFOLIO'],
            defaultScopeKind: 'CLIENT',
            organizationRequired: true,
            branchRequired: true,
            clientRequired: true,
            portfolioOptional: true,
        },
        ownershipPolicy: 'OWN_CLIENT',
        defaultLandingRouteId: ROUTE_IDS.DASHBOARD,
        navigation: {
            candidatePrimaryRouteIds: [...CLIENT_PRIMARY_NAVIGATION],
            avatarRouteIds: [...AVATAR_PLATFORM],
            structurallyForbiddenRouteIds: [ROUTE_IDS.ADMIN_HUB, ROUTE_IDS.DATA_HUB],
            conditionallyAvailableRouteIds: [ROUTE_IDS.HOLDINGS, ROUTE_IDS.TRANSACTIONS],
        },
        administration: {
            managesOrganizations: false,
            managesPlatformModules: false,
            managesPlatformUsers: false,
            managesBranches: false,
            managesOrganizationModules: false,
            managesOrganizationUsers: false,
            managesRoles: false,
            managesClients: false,
        },
        dataVisibility: {
            platformMetadata: false,
            organizationBusinessData: 'OWN_CLIENT',
        },
        mutationPolicy: 'READ_ONLY',
        defaultPermissionBundleIds: ['organization.client.base'],
        baselineModuleIds: CLIENT_MODULES,
        principalContextSwitching: {
            organization: false,
            branch: false,
        },
        resourceScopeSelection: {
            client: false,
            portfolio: true,
        },
        supportDelegation: {
            mayInitiate: false,
            mayReceive: false,
            organizationDataRequiresDelegation: false,
        },
    },
};
